import { Row } from "antd";

type SelectOptionProps = {
  name: string;
  item: any;
  showEmail: boolean;
  isEmailView?: boolean;
};

export const SelectOption = ({
  item,
  name,
  showEmail,
  isEmailView,
}: SelectOptionProps) => {
  return (
    <Row className="justify-space-between align-center">
      <Row className={`d-block main-info ${isEmailView ? "short" : ""}`}>
        <p className="my-0 text-md w-500 elipsis">{name}</p>
        {!item.isEmail && showEmail && (
          <p className="my-0 text-sm title default-bg additional-info">
            {item.email}
          </p>
        )}
      </Row>
      <Row className="mx-2 additional-info">
        {item.role && (
          <span className="text-sm title default-bg">
            Primary {item.role === 1 ? "Buyer" : "Seller"}&nbsp;|&nbsp;
          </span>
        )}
        {!item.isEmail && (
          <span className="text-sm title default-bg">#{item.number}</span>
        )}
      </Row>
    </Row>
  );
};
